import React from "react";
import EncounterHistoryComponent from "components/community/EncounterHistory";

const EncounterHistory = () => {
  return (
    <>
      <div className="main-contents">
        <EncounterHistoryComponent />
      </div>
    </>
  );
};

export default EncounterHistory;
